import { render, staticRenderFns } from "./changeMobile.vue?vue&type=template&id=4c0a800c&scoped=true&"
import script from "./changeMobile.vue?vue&type=script&lang=js&"
export * from "./changeMobile.vue?vue&type=script&lang=js&"
import style0 from "./changeMobile.vue?vue&type=style&index=0&id=4c0a800c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a800c",
  null
  
)

export default component.exports